import React from "react";

export function FilterDropdown(data) {
  return data.map(item => ({
    ...item,

    facility: item?.facility?.length ? (
      <div className="dropdown">
        <button
          className="btn btn-sm btn-outline-secondary dropdown-toggle"
          type="button"
          data-bs-toggle="dropdown"
        >
          Facilities
          <span className="badge bg-secondary ms-2">
            {item.facility.length}
          </span>
        </button>

        <ul className="dropdown-menu dropdown-menu-end">
          {item.facility.map((f, index) => (
            <li key={index}>
              <span className="dropdown-item">
                <i className="bi bi-check2-circle me-2"></i>
                {typeof f === "object" ? f.name : f}
              </span>
            </li>
          ))}
        </ul>
      </div>
    ) : null,
  }));
}
